module.exports = __webpack_public_path__ + "img/cockpit-example.3b98f8f9.jpg";